import { api } from "@/lib/api";

export const FORMATS = [
  { value: "course", label: "Full Course", time: "Multi-lesson · hours to weeks", blurb: "A complete path from zero to skilled.",
    lessons: ["Welcome & what you'll be able to do", "Core concept #1", "Core concept #2", "Hands-on project", "Next steps & getting paid"] },
  { value: "class", label: "Single Class", time: "One session · 30–90 min", blurb: "One focused class on one skill.",
    lessons: ["The class"] },
  { value: "lecture", label: "Quick Lecture", time: "5–15 minutes", blurb: "A tight, high-value lesson. In and out.",
    lessons: ["The lecture"] },
  { value: "series", label: "Ongoing Series", time: "New episodes over time", blurb: "Keep teaching. Add episodes whenever you like.",
    lessons: ["Episode 1"] },
];

export const formatLabel = (v) => FORMATS.find((f) => f.value === v)?.label || "Full Course";

export const CATEGORIES = ["Business & Skills", "AI Tools", "Tech & Coding", "Creative & Design", "Trades & Hands-on",
  "Money & Investing", "Marketing & Sales", "Health & Fitness", "Languages", "Other"];

export const newLesson = (title = "") => ({ id: `l_${Math.random().toString(36).slice(2, 10)}`, title, body: "", duration: "", media: [], quiz: [] });

export const apiError = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ");
  return fallback;
};

export async function uploadMedia(file, onProgress) {
  const { data: init } = await api.post("/media/upload/init", { filename: file.name, size: file.size });
  const size = init.chunk_size;
  const total = Math.max(1, Math.ceil(file.size / size));
  for (let i = 0; i < total; i += 1) {
    const form = new FormData();
    form.append("index", String(i));
    form.append("chunk", file.slice(i * size, (i + 1) * size), file.name);
    let tries = 0;
    for (;;) {
      try { await api.post(`/media/upload/${init.upload_id}/chunk`, form); break; }
      catch (e) { tries += 1; if (tries >= 3) throw e; }
    }
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post(`/media/upload/${init.upload_id}/complete`);
  onProgress?.(100);
  return data;
}

export const isIndia = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return tz === "Asia/Kolkata" || tz === "Asia/Calcutta" || (navigator.language || "").endsWith("-IN");
  } catch { return false; }
};
